<template>
  <div class="login-container">
    <div class="login-box">
      <div class="login-header">
        <img src="/Logo.png" alt="Logo" class="logo" />
        <h2>欢迎登录</h2>
      </div>

      <el-form
        ref="loginForm"
        :model="loginForm"
        :rules="rules"
        class="login-form"
      >
        <el-form-item prop="username">
          <el-input
            v-model="loginForm.username"
            prefix-icon="el-icon-user"
            placeholder="请输入用户名"
            clearable
          />
        </el-form-item>
        <el-form-item prop="password">
          <el-input
            v-model="loginForm.password"
            prefix-icon="el-icon-lock"
            type="password"
            placeholder="请输入密码"
            show-password
            clearable
            @keyup.enter.native="submitForm"
          />
        </el-form-item>

        <el-form-item class="login-button">
          <el-button type="primary" :loading="loading" @click="submitForm" round>
            {{ loading ? '登录中...' : '登 录' }}
          </el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import http from "../api/http";
export default {
  data() {
    return {
      loading: false,
      loginForm: {
        username: "",
        password: "",
      },
      rules: {
        username: [
          { required: true, message: "请输入用户名", trigger: "blur" },
        ],
        password: [
          { required: true, message: "请输入密码", trigger: "blur" },
        ],
      },
    };
  },
  methods: {
    submitForm() {
      this.$refs.loginForm.validate((valid) => {
        if (valid) {
          this.loading = true;
          http.post("/api/user/login", this.loginForm)
            .then((res) => {
              if (res.data.code === 1) {
                this.$message({
                  type: "success",
                  message: "登录成功",
                  duration: 1500
                });
                localStorage.setItem("token", res.data.data.token);
                localStorage.setItem("role", res.data.data.role);
                setTimeout(() => {
                  this.$router.push("/HelloWorld");
                }, 1000);
              } else {
                this.$message.error(res.data.msg);
              }
            })
            .catch(() => {
                this.$message.error("登录失败，请稍后重试");
            })
            .finally(() => {
              this.loading = false;
            });
        }
      });
    },
  },
  mounted() {
    // 如果已经登录，直接跳转到首页
    if (localStorage.getItem("token")) {
      this.$router.push("/HelloWorld");
    }
  },
};
</script>

<style scoped>
.login-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  padding: 20px;
}

.login-box {
  width: 400px;
  padding: 40px;
  background: rgba(255, 255, 255, 0.95);
  border-radius: 16px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  backdrop-filter: blur(10px);
  animation: fadeIn 0.5s ease-out;
}

.login-header {
  text-align: center;
  margin-bottom: 40px;
}

.logo {
  width: 120px;
  height: auto;
  margin-bottom: 20px;
  animation: logoFloat 3s ease-in-out infinite;
}

.login-header h2 {
  color: #333;
  font-size: 24px;
  margin: 0;
  font-weight: 500;
}

.login-form {
  margin-top: 30px;
}

.login-form :deep(.el-input__inner) {
  height: 45px;
  line-height: 45px;
  border-radius: 23px;
  padding-left: 45px;
  border: 1px solid #dcdfe6;
  transition: all 0.3s;
}

.login-form :deep(.el-input__inner:focus) {
  border-color: #764ba2;
  box-shadow: 0 0 0 2px rgba(118, 75, 162, 0.1);
}

.login-form :deep(.el-input__prefix) {
  left: 15px;
}

.login-button {
  margin-top: 40px;
}

.login-button :deep(.el-button) {
  width: 100%;
  height: 45px;
  font-size: 16px;
  letter-spacing: 4px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border: none;
  transition: transform 0.3s, box-shadow 0.3s;
}

.login-button :deep(.el-button:hover) {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(118, 75, 162, 0.2);
}

.login-button :deep(.el-button:active) {
  transform: translateY(0);
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes logoFloat {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-10px);
  }
}

/* 响应式设计 */
@media (max-width: 480px) {
  .login-box {
    width: 100%;
    padding: 30px 20px;
  }
}
</style>